<style scoped lang="stylus">
.info-banner
  position: relative
  width: 100vw
  left: 50%
  right: 50%
  margin-left: -50vw
  margin-right: -50vw
  background-color: #D6F0FA
  border: 1px solid #126877
  display: flex
  justify-content: space-between
  align-items: center
  padding: 8px 24px
  font-family: Arial, sans-serif
  font-size: 14px
  line-height: 20px
  flex-wrap: wrap

.info-banner__center-wrapper
  display: flex
  justify-content: center
  flex: 1
  max-width: 605px
  margin: 0 auto
  width: 100%

.info-banner__left
  display: flex
  align-items: center
  gap: 8px
  max-width: 800px

.info-banner__text
  font-weight: 400
  color: #126877
  margin: 0
  padding-left: 2px
  text-indent: -2px
  display: block
  line-height: 20px

.info-banner__text strong
  font-weight: 700

.info-banner__text a
  color: #126877
  text-decoration: underline


.info-banner__close
  font-size: 22px !important
  color : #126877 !important
  font-weight: 400
  cursor: pointer

.info-banner__close-button
  background: none
  border: none
  padding: 0
  margin-left: 12px
  cursor: pointer
  display: flex
  align-items: center
  justify-content: center

@media (max-width: 768px)
  .info-banner
    flex-wrap: wrap
    flex-direction: row
    align-items: center
    padding: 12px


  .info-banner__center-wrapper
    flex: 1
    margin: 0
    max-width: 100%

  .info-banner__left
    align-items: center
    gap: 8px
    text-align: left
    max-width: 100%

  .info-banner__text
    max-width: 100%
    padding-left: 2px
    text-indent: -2px
    margin: 0

  .info-banner__close
    font-size: 20px
    position: initial
    top: 12px
    right: 12px
</style>

<template>
  <div class="info-banner" v-if="show">
    <div class="info-banner__center-wrapper">
      <div class="info-banner__left">
        <v-icon color="#126877" size="24"> mdi-information-slab-circle </v-icon>
        <p class="info-banner__text">
          <strong>ASU email accounts:</strong>
          ASU no longer provides asu.edu emails for new learners registering for Universal Learner Courses. For more
          details, please contact
          <a
            :href="ulcPartnerFlag ? 'https://ulc.asu.edu/help-center/' : 'https://ea.asu.edu/help-center/'"
            target="_blank"
            rel="noopener"
            >support</a
          >.
        </p>
      </div>
    </div>
    <button @click="handleClose" class="info-banner__close-button" aria-label="Close banner">
      <v-icon class="info-banner__close">mdi-close</v-icon>
    </button>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

import { Helper } from '../mixins/helpers';

export default defineComponent({
  emits: ['close'],
  name: 'InfoBanner',

  props: {
    show: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    handleClose() {
      this.$emit('close');
    }
  },

  computed: {
    ulcPartnerFlag() {
      return Helper.methods.isUlcPartner();
    }
  }
});
</script>
